__turbopack_context__.v({
  "codeHandlingWrapper": "Kl9RiW_codeHandlingWrapper",
  "counterDisplay": "Kl9RiW_counterDisplay",
  "expiredCode": "Kl9RiW_expiredCode",
  "modalActions": "Kl9RiW_modalActions",
  "modalContent": "Kl9RiW_modalContent",
  "resendCountdownPending": "Kl9RiW_resendCountdownPending",
  "resendCountdownResolved": "Kl9RiW_resendCountdownResolved",
  "wrapper": "Kl9RiW_wrapper",
});
